// vendor
import { fork } from 'redux-saga/effects'
import debug from 'debug'
import { watchGetConfigJson } from './general'
import { watchGetGithubData } from './github'
import { watchPostOrg } from './create-org'
import { watchPostUser } from './create-user'
import { watchGetExpiredExtendTrial } from './expired'
import { watchPostInviteUsers } from './invite-users'
import { watchPostLink } from './link'
import { watchPostLogin } from './login'
import {
  watchPostPasswordRecovery,
  watchPostPasswordSet,
  watchPostPasswordReset,
} from './password'
import { watchPostSSO, watchPostSSOLink } from './sso'
import { watchPostUsernameRecovery } from './username'
import {
  watchGeneratePhoneVerify,
  watchRegeneratePhoneVerify,
  watchConfirmPhoneVerify,
} from './verify-phone'

const error = debug('vo:sagas:error')

export default function makeRootSaga(api) {
  return function* rootSaga() {
    yield fork(watchGetConfigJson, api, error)
    yield fork(watchGetGithubData, api, error)
    yield fork(watchPostOrg, api, error)
    yield fork(watchPostUser, api, error)
    yield fork(watchGetExpiredExtendTrial, api, error)
    yield fork(watchPostInviteUsers, api, error)
    yield fork(watchPostLink, api, error)
    yield fork(watchPostLogin, api, error)
    yield fork(watchPostPasswordRecovery, api, error)
    yield fork(watchPostPasswordSet, api, error)
    yield fork(watchPostPasswordReset, api, error)
    yield fork(watchPostSSO, api, error)
    yield fork(watchPostSSOLink, api, error)
    yield fork(watchPostUsernameRecovery, api, error)
    yield fork(watchGeneratePhoneVerify, api, error)
    yield fork(watchRegeneratePhoneVerify, api, error)
    yield fork(watchConfirmPhoneVerify, api, error)
  }
}
